<template>
  <div class="layout">
    <Layout>
      <Row class="title">
        <Icon type="ios-arrow-back" class="arrow" @click="backClick()"/>
        <span>{{$t('message.A_fake_counterfeits')}}</span>
      </Row>
      <Row class="container">
        <Form ref="form" :model="form" :rules="rule">
          <FormItem prop="name">
            <Input type="text" :placeholder="$t('message.inform_input_name')" size="large" v-model="form.name"></Input>
          </FormItem>
          <FormItem prop="email">
            <Input type="text" :placeholder="$t('message.inform_input_email')" size="large" v-model="form.email"></Input>
          </FormItem>
          <FormItem prop="phone_num">
            <Input type="text" :placeholder="$t('message.inform_input_number')" size="large"
                   v-model="form.phone_num"></Input>
          </FormItem>
          <FormItem prop="feedback">
            <Input type="textarea" :rows="4" :placeholder="$t('message.inform_input_feedback')" size="large"
                   v-model="form.feedback"></Input>
          </FormItem>
        </Form>
      </Row>
      <Row type="flex" justify="start">
<!--        <div class="demo-upload-list" v-for="item in uploadList">-->
<!--          <template>-->
<!--            <img :src="item.url">-->
<!--            <div class="demo-upload-list-cover">-->
<!--              <Icon type="ios-trash-outline" @click="handleRemove(item)"></Icon>-->
<!--            </div>-->
<!--          </template>-->
<!--        </div>-->
<!--        <Upload-->
<!--            ref="upload" :show-upload-list="false" :max-size="2048"-->
<!--            type="drag" :format="['jpg','jpeg','png']" :on-format-error="handleFormatError"-->
<!--            :on-exceeded-size="handleMaxSize" :before-upload="handleUpload" multiple-->
<!--            action="//jsonplaceholder.typicode.com/posts/"-->
<!--            style="display: inline-block;width:100px;">-->
<!--          <div style="width: 100px;height:100px;line-height: 100px;">-->
<!--            <Icon type="ios-add" size="40" color="#dcdee2"></Icon>-->
<!--          </div>-->
<!--        </Upload>-->
      </Row>
      <Row class="container">
        <Button class="btn" long type="primary" @click="handleSubmit('form')">
          {{$t('message.inform_input_submit')}}
        </Button>
      </Row>
    </Layout>
  </div>
</template>

<script>
  export default {
    name: "Inform",
    data() {
      return {
        form: {
          name: '',
          email: '',
          phone_num: '',
          // store_address: '',
          feedback: ''
        },
        rule: {
          name: [
            {required: true, message: 'Please fill in the name', trigger: 'blur'}
          ],
          email: [
            {required: true, message: 'Please fill in the Email address', trigger: 'blur'},
            {type: 'email', message: 'Incorrect email format', trigger: 'blur'}
          ],
          phone_num: [
            {required: true, message: 'Please fill in the Phone number', trigger: 'blur'}
          ],
          // store_address: [
          //   {required: true, message: 'Please fill in the Store address', trigger: 'blur'}
          // ],
          feedback: [
            {required: true, message: 'Please fill in the Feedback content', trigger: 'blur'}
          ]
        },
        uploadList: []
      }
    },
    methods: {
      backClick() {
        this.$router.go(-2);
      },
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let _me = this;
            // console.log(_me.form);
            let params = {
              type: 6,
              reason: _me.form.feedback,
              name: _me.form.name,
              email: _me.form.email,
              tel: _me.form.phone_num,
              images: ''
            };
            _me.common.httpPost('report/add', params)
              .then((res) => {
                _me.$Modal.info({
                  title: _me.$t('message.success'),
                  content: res.message
                });
              })
              .catch(err => {
                _me.$Modal.info({
                  title: _me.$t('message.error'),
                  content: err
                });
              });
          } else {
            this.$Message.error('Fail');
          }
        });
      },
      handleFormatError(file) {
        this.$Notice.warning({
          title: 'The file format is incorrect',
          desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
        });
      },
      handleMaxSize(file) {
        this.$Notice.warning({
          title: 'Exceeding file size limit',
          desc: 'File  ' + file.name + ' is too large, no more than 2M.'
        });
      },
      handleRemove(file) {
        this.uploadList.splice(this.uploadList.indexOf(file), 1)
      },
      handleUpload(file) { // 上传文件前的事件钩子
        let reader = new FileReader();
        // 读取文件作为 URL 可访问地址
        reader.readAsDataURL(file);
        const _this = this;
        reader.onloadend = function (e) {
          // console.log(reader.result);
          file.url = reader.result;
          _this.uploadList.push(file);
        };
        return false;
      },
    }
  }
</script>

<style scoped>
  .img_upload {
    margin-bottom: 2rem;
  }
  .demo-upload-list{
    display: inline-block;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }

  .demo-upload-list-cover i{
    color: #fff;
    font-size: 40px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
